import './HeroBanner.scss';
// import Swiper core and required modules
import { Navigation, A11y } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import ButtonIconGhostSmall from '../../common/ButtonIconGhost/ButtonIconGhostSmall';
import { Icon } from '../../icon/icon';
import { Divider } from 'antd';
import { useRef, useState } from 'react';

const HeroBanner = () => {
  const swiperRef = useRef(null);
  const [showNavigate, setShowNavigate] = useState(true);

  return (
    <section className="hero-banner w-full flex lg:p-[24px] lg:px-[20px] p-[16px] flex-col items-start lg:gap-[32px] gap-[6px] user-select-none">
      <Swiper
        // install Swiper modules
        ref={swiperRef}
        modules={[Navigation, A11y]}
        spaceBetween={50}
        slidesPerView={1}
        navigation={{
          prevEl: '.custom-swiper-button-prev',
          nextEl: '.custom-swiper-button-next',
        }}
        onSwiper={swiper => setShowNavigate(swiper.slides.length > 1)}
      >
        <SwiperSlide>
          <div className="lg:h-[540px] flex flex-col items-center justify-center gap-[40px] text-white w-full lg:rounded-[24px] rounded-[16px] overflow-hidden">
            <img
              src="https://d391nxox3m93fb.cloudfront.net/fitta_site_images/hero.webp"
              alt="Hero"
              className="object-cover w-full"
            />
          </div>
        </SwiperSlide>
      </Swiper>
      {showNavigate && (
        <div className="flex justify-end items-center gap-8 self-stretch">
          <div className="custom-navigation flex py-4 px-8 items-center gap-8 rounded-[100px] bg-fills-white">
            <ButtonIconGhostSmall
              icon={<Icon.ICPrev />}
              className="custom-swiper-button-prev"
            />
            <Divider
              type="vertical"
              style={{ margin: 0, background: '#E6E7E7', height: '24px' }}
            />
            <ButtonIconGhostSmall
              icon={<Icon.ICNext />}
              className="custom-swiper-button-next"
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default HeroBanner;
